import { createContext, useContext, useEffect, useState } from "react";
import { MotionConfig } from "framer-motion";

const KEY = "pp_pause_motion";
const Ctx = createContext({ paused: false, toggle: () => {} });

const initial = () => {
  const saved = localStorage.getItem(KEY);
  if (saved !== null) return saved === "1";
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

// Pauses autoplaying video (except player videos with controls) while motion is paused.
function pauseVideos() {
  document.querySelectorAll("video:not([controls])").forEach((v) => {
    v.removeAttribute("autoplay");
    v.autoplay = false;
    v.pause();
  });
}

export function MotionPrefProvider({ children }) {
  const [paused, setPaused] = useState(initial);

  useEffect(() => {
    localStorage.setItem(KEY, paused ? "1" : "0");
    document.documentElement.classList.toggle("motion-paused", paused);
    if (!paused) {
      document.querySelectorAll("video[data-ambient]").forEach((v) => v.play().catch(() => {}));
      return undefined;
    }
    pauseVideos();
    const obs = new MutationObserver(pauseVideos);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, [paused]);

  return (
    <Ctx.Provider value={{ paused, toggle: () => setPaused((p) => !p) }}>
      <MotionConfig reducedMotion={paused ? "always" : "user"}>{children}</MotionConfig>
    </Ctx.Provider>
  );
}

export const useMotionPref = () => useContext(Ctx);
